import(/* webpackMode: "eager", webpackExports: ["CompanyPage"] */ "C:\\Users\\HP\\Desktop\\rombex_web\\rombex-homepage-design-main\\components\\company-page.tsx");
